import { Box, DashboardModule, SortableList } from '@domain-group/suit-theme'

import type { ProviderPriceListItemOptionValueModel } from '@models/types'

import useEditProviderPriceListItemOptionValueSort from './hooks/useProviderPriceListItemOptionValueSort'

import DraggableProviderPriceListOptionValue from './DraggableProviderPriceListOptionValue'

interface PriceListItemOptionValueSortableListProps {
  isMaster: boolean,
  providerPriceListItemOptionValues: ProviderPriceListItemOptionValueModel[],
}

const PriceListItemOptionValueSortableList = (props: PriceListItemOptionValueSortableListProps) => {
  const { isMaster, providerPriceListItemOptionValues } = props

  const sortPayload = useEditProviderPriceListItemOptionValueSort(
    { filteredProviderPriceListItemOptionValues: providerPriceListItemOptionValues },
  )
  const { callbacks: { modifyProviderPriceListItemOptionValueSort }, sortedIds } = sortPayload

  return (
    <SortableList
      callbacks={{
        onDragEnd: (fromIndex, toIndex, payload) => {
          if (toIndex === undefined) return
          modifyProviderPriceListItemOptionValueSort(
            fromIndex,
            payload,
            toIndex,
          )
        },
      }}
    >
      <DashboardModule.ScrollableSection>
        <SortableList.Dropzone droppableId="sortedIds">
          <Box flexDirection="column">
            {sortedIds.map((providerPriceListItemOptionValueId, index) => (
              <SortableList.Item
                draggableId={`ProviderPriceListOptionValue-${providerPriceListItemOptionValueId}`}
                index={index}
                key={providerPriceListItemOptionValueId}
              >
                <DraggableProviderPriceListOptionValue
                  isMaster={isMaster}
                  isFirstItem={index === 0}
                  providerPriceListItemOptionValueId={providerPriceListItemOptionValueId!}
                />
              </SortableList.Item>
            ))}
          </Box>
        </SortableList.Dropzone>
      </DashboardModule.ScrollableSection>
    </SortableList>
  )
}

export default PriceListItemOptionValueSortableList
